import type { ProductState } from 'src/redux/product/types';
import type { ProductJSONLDSchema } from 'src/types/productJSONLDSchema';

type AggregateRating = ProductJSONLDSchema['aggregateRating'];

/**
 * Prefers UPS ratings over cat-service's, so the structured data and the
 * "What customers think" summary quote the same numbers. Both are fetched
 * server-side, which is why the summary reads UPS rather than the Feefo
 * breakdown DISC-4325 moved to a client fetch: structured data has to be in
 * the server-rendered markup to be worth emitting at all.
 *
 * Falls back to cat-service when UPS has no ratings for the product, rather
 * than dropping the rich result the page already earns today.
 */
export const getAggregateRatingJSONLDSchema = (product: ProductState): AggregateRating => {
  const { numberOfReviews, productRating, ratings } = product;

  if (ratings) {
    return {
      '@type': 'AggregateRating',
      ratingValue: ratings.averageRating,
      reviewCount: ratings.ratingCount,
    };
  }

  if (numberOfReviews > 0 && typeof productRating === 'number') {
    return {
      '@type': 'AggregateRating',
      ratingValue: productRating,
      reviewCount: numberOfReviews,
    };
  }

  return undefined;
};
